// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_APP_VERSION = "v1";
export const VERSION_DATE = "June 25. 2026";
export const VERSION_TAG = "V.2.2.8";

export const VARIANT_VX = "vx";

export const VARIANT_OPTIONS = [
	{
		key: "v2",
		label: "LA Metro Gateway",
		icon: "trainSubway",
	},
	{
		key: "v3",
		label: "LA Metro Railway",
		icon: "train",
	},
];
